<template>
  <div v-loading="loading">
    <div class="coupon-head">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="item"
        :class="{ cur: index === current }"
        @click="handleTab(item, index)"
      >{{ item.name }}</div>
    </div>
    <div class="coupon-list">
      <div v-for="(item, index) in list" :key="index" class="item">
        <div class="card">
          <div class="head">
            <div class="value">
              {{ unit }}
              <span>{{ item.money }}</span>
            </div>
            <div class="cont">
              <div class="name">{{ item.name }}</div>
              <div class="desc">{{ lang.desc_text1 }}{{ item.fullmoney }}{{ unit }}</div>
            </div>
            <div>
              <div v-if="states === 0" class="btn" @click="handleUse(item)">{{ lang.use_btn }}</div>
              <div v-if="states === 1" class="btn disabled">{{ lang.used_btn }}</div>
              <div v-if="states === 2" class="btn disabled" @click="handleUse(item)">{{ lang.expired_btn }}</div>
              <el-popover
                v-if="item.des"
                placement="bottom"
                :title="lang.use_desc"
                width="300"
                trigger="click"
                :content="item.des">
                <div class="btn-link" slot="reference">{{ lang.use_desc }}</div>
              </el-popover>
            </div>
          </div>
          <div class="footer">
            <div class="cont">
              <div class="item-text">{{ lang.coupon_desc1 }}：{{ item.starttime }}至{{ item.endtime }}</div>
              <div class="item-text">{{ lang.coupon_desc2 }}-{{ item.isappoint === 0 ? lang.all_available : lang.part_available }}</div>
              <div class="item-text">{{ lang.coupon_desc3 }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="list.length === 0" class="empty-box">
        <el-empty :description="lang.no_coupon" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getcouponlist } from '@/api/user'
export default {
  data() {
    return {
      loading: false,
      tabList: this.$t('coupon_list').coupon_state,
      states: 0,
      current: 0,
      list: []
    }
  },
  computed: {
    lang() {
      return this.$t('coupon_list')
    },
    ...mapGetters(['unit', 'user'])
  },
  created() {
    this.getList()
  },
  methods: {
    handleTab(item, index) {
      this.states = item.states
      this.current = index
      this.getList()
    },
    getList() {
      this.loading = true
      getcouponlist({ states: this.states }).then(({ data }) => {
        this.list = data
        this.loading = false
      })
    },
    handleUse(item) {
      if (item.isappoint === 0) {
        this.$router.push('/')
      } else {
        const { vemId } = JSON.parse(item.productno)[0]
        if (vemId.indexOf('GA') !== -1) {
          this.$router.push(`/home/machine?type=1`)
        } else {
          this.$router.push(`/home/machine?type=2`)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-head {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  border: 1px solid rgba(236, 146, 33, 0.3);
  background-color: #fff;
  margin-bottom: 10px;
  .item {
    text-align: center;
    flex: 1 1 auto;
    color: #aaaaaa;
    font-size: 12px;
    &:hover {
      cursor: pointer;
    }
    &.cur {
      position: relative;
      color: #000000;
      &::after {
        content: ' ';
        position: absolute;
        left: 50%;
        bottom: -2px;
        width: 36px;
        margin-left: -18px;
        height: 1px;
        background-color: #ec9221;
      }
    }
  }
}
.coupon-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &::after {
    content: ' ';
    width: 315px;
  }
  .item {
    width: 285px;
    border-radius: 12px;
    background-color: #fff;
    margin-bottom: 10px;
    padding: 0 15px;
    .head {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      padding: 15px 0;
      .value {
        color: #ff0000;
        font-size: 10px;
        margin-right: 20px;
        span {
          font-size: 20px;
          font-weight: 700;
          padding-left: 4px;
        }
      }
      .cont {
        flex: 1;
      }
      .name {
        color: #4f4f4f;
        font-size: 14px;
        padding-bottom: 4px;
      }
      .desc {
        color: #aaaaaa;
        font-size: 10px;
      }
      .btn-link {
        margin: 6px 6px 0 0;
        text-align: right;
        color: #ec9221;
        font-size: 12px;
        cursor: pointer;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 66px;
        height: 24px;
        background: #ec9221;
        border-radius: 30px;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
        &.disabled {
          background-color: #ccc;
        }
      }
    }
    .footer {
      padding: 15px 0;
      color: #aaaaaa;
      font-size: 10px;
      .item-text {
        margin-bottom: 4px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
.empty-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>